import React, { useRef, useMemo } from 'react';
//import { Accordion, Card , useAccordionButton} from 'react-bootstrap';
import 'viewerjs/dist/viewer.css';
import PendingFG from '../images/FG-pending.png';
import PendingAH from '../images/AH-pending.png';

//import {photos} from './dummy/photos';
import { ChevronRight, ChevronDoubleRight } from 'react-bootstrap-icons';
import GLIFOSMetadataViewer from './GLIFOSMetadataViewer';
import GLIFOSImageViewer from './GLIFOSImageViewer';
import GLIFOSPdfViewer from './GLIFOSPdfViewer';
import GLIFOSViewerTools from './GLIFOSViewerTools';
import GLIFOSLigthBox from './GLIFOSLigthBox';
import { removeRightClick } from '../utilities/util';

export default function GLIFOSViewer(props) {
	const { itemInfo, apiService, inventory = null } = props;
	const metadataContainerRef = useRef(null);
	//console.log(itemInfo);
	let fileOb =
		itemInfo.digitalfile != null
			? itemInfo.digitalfile
			: {
					mime: 'not/defined',
			  };

	function handleClick(ev) {
		ev.stopPropagation();
		ev.preventDefault();
		metadataContainerRef.current.classList.toggle('displayed-md');
	}
	function handleClickLarger(ev) {
		ev.stopPropagation();
		ev.preventDefault();
		metadataContainerRef.current.classList.toggle('displayed-md');
		metadataContainerRef.current.classList.toggle('displayed-extra');
	}

	const innerWidth = useMemo(() => window.innerWidth, []);
	return (
		<div
			className={`g-vc-wr ${innerWidth > 768 ? 'displayed-md' : ''}`}
			id='gdac830'
			ref={metadataContainerRef}
		>
			<div className='g-md-c d-flex position-relative flex-column h-100 flex-grow-1'>
				<div className='g-md-exc position-absolute'>
					<div onClick={handleClick}>
						<ChevronRight />
					</div>
					<div onClick={handleClickLarger}>
						<ChevronDoubleRight />
					</div>
				</div>
				<div className='g-mdacc d-flex flex-grow-1'>
					<GLIFOSMetadataViewer
						itemInfo={itemInfo}
						inventory={inventory}
					/>
				</div>
			</div>
			<div
				className='g-vw-c'
				id='gdac-v'
				onContextMenu={removeRightClick}
			>
				{fileOb.mime === 'application/pdf' ? (
					<GLIFOSPdfViewer
						itemInfo={itemInfo}
						apiService={apiService}
						isadg={itemInfo?.isadg?.code}
						images={[
							itemInfo?.agency?.code === 'GT-CIRMA-FG'
								? PendingFG
								: PendingAH,
						]}
						file={apiService.__getFileSrc(fileOb.file_id)}
					/>
				) : fileOb.mime === 'image/jpeg' ||
				  fileOb.mime === 'image/jpg' ||
				  fileOb.mime === 'image/png' ? (
					<GLIFOSImageViewer
						apiService={apiService}
						images={[apiService.__getFileSrc(fileOb.file_id)]}
						alts={[itemInfo?.isadg?.display_name]}
						isadg={itemInfo?.isadg?.code}
						itemInfo={itemInfo}
					/>
				) : (
					<GLIFOSImageViewer
						itemInfo={itemInfo}
						apiService={apiService}
						images={[
							itemInfo?.agency?.code === 'GT-CIRMA-FG'
								? PendingFG
								: PendingAH,
						]}
						alts={[itemInfo?.isadg?.display_name]}
						isadg={itemInfo?.isadg?.code}
					/>
				)}
				<GLIFOSViewerTools itemInfo={itemInfo} />

				{itemInfo?.children_count > 0 &&
					itemInfo?.metadata?.identificacion?.nivel_descripcion?.__content?.toLowerCase() ===
						'expediente' && (
						<GLIFOSLigthBox
							itemInfo={itemInfo}
							apiService={apiService}
						/>
					)}
			</div>
		</div>
	);
}
